<div class="function-test-container">
  <h3>Test Function</h3>

    @if (!functionOption) {
        <div class="error-message">
            No function data available.
        </div>
    }

    @if (functionOption) {
        <div>
            <p class="function-description">
                <strong>Function:</strong> {{ functionOption.name }}<br>
                <strong>Type:</strong> {{ functionOption.type }}<br>
                <strong>Description:</strong> {{ functionOption.description || 'No description available' }}
            </p>
            <p class="function-description">
                Tests use deterministic synthetic fixtures only. They do not invoke the configured endpoint or workflow.
            </p>
            <div class="test-form-container">
                <form (ngSubmit)="testFunction()" [formGroup]="testForm">
                    <mat-form-field appearance="fill" class="full-width">
                        <mat-label>Synthetic fixture</mat-label>
                        <mat-select [value]="fixture" (selectionChange)="fixture = $event.value">
                            @for (fixtureOption of fixtures; track fixtureOption.value) {
                                <mat-option [value]="fixtureOption.value">{{ fixtureOption.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (parameters.length === 0) {
                        <div class="no-params-message">
                            No parameters defined for this function.
                        </div>
                    }
                    @for (param of parameters; track param) {
                        <div class="parameter-field">
                            <mat-form-field appearance="fill" class="full-width">
                                <mat-label>{{ param.name }}{{ param.required ? ' *' : '' }}</mat-label>
                                <input [formControlName]="param.name" [placeholder]="'Enter ' + param.name" matInput>
                                @if (param.description) {
                                    <mat-hint>{{ param.description }}</mat-hint>
                                }
                                @if (testForm.get(param.name)?.invalid && testForm.get(param.name)?.touched) {
                                    <mat-error>
                                        This field is required
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    <div class="action-buttons">
                        <button [disabled]="testForm.invalid || isLoading || !!workflowTestBlockedReason()" color="primary" mat-raised-button
                                type="submit">
                            {{ isLoading ? 'Testing...' : 'Test Function' }}
                        </button>
                    </div>
                    @if (workflowTestBlockedReason(); as reason) {
                        <div class="no-params-message">
                            {{ reason }}
                        </div>
                    }
                </form>
            </div>
            @if (testResult) {
                <div class="test-result">
                    <h4>Test Result</h4>
                    <pre>{{ testResult | json }}</pre>
                </div>
            }
        </div>
    }
</div>
